import { formatPhoneNumberIntl } from 'react-phone-number-input'

export const phoneFormatter = (phone) => {
  const phoneSplitted = formatPhoneNumberIntl(phone).split(' ')
  const phoneNumber = phoneSplitted.slice(1).join('')
  const phoneFormatted = [phoneSplitted[0], phoneNumber].join(' ')
  return phoneFormatted
}
